import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faStar } from '@fortawesome/free-solid-svg-icons'

export class Preview extends Component {

  render () {
    const {listing, featured} = this.props
    const kmListing = listing.listAgentFullName === "Kevin Mackin";

    return (
        <div className="preview" title="Click for Details">
            <Link to={`/property/${listing.listingId}`}>
                <div>
                    <img alt={listing.listingId} src={`${listing.photo}?w=360`} className="img-fluid"></img>
                </div>
                <div className="mt-2">
                    <p className="sm bold">{listing.listingId}</p>
                    <p className="sm">{listing.subdivisionName}</p>
                    <p className="sm">{listing.street}</p>
                    <p className="sm">{listing.city}, FL</p>
                    { listing.listingType !== "Land" &&
                        <p className="sm"><span className="bold">{listing.currentPrice}</span> | {listing.roomCount} Beds, {listing.bathroomsFull}/{listing.bathroomsHalf} Baths</p>
                    }
                    { listing.listingType === "Land" &&
                        <Fragment>
                            <p className="sm"><span className="bold">{listing.currentPrice}</span> | {listing.lotSizeAcres} acres, {listing.waterfrontYN}</p>
                            <p className="sm">Land</p>
                        </Fragment>
                    }
                    <p className="sm">{listing.daysOnMarket} days on market</p>
                </div>
                { !featured && !kmListing &&
                    <div className="footer">
                        This listing is courtesy of {listing.listOfficeName}
                    </div>
                }
                { !featured && kmListing &&
                    <p className="sm bold mt-2"><FontAwesomeIcon icon={faStar} size="lg" style={{color: "gold"}}/> Another Kevin Mackin Listing</p>
                }

            </Link>
        </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Preview.jsx